import "./SingleProject.scss";

const SingleProject = (props) => {



    return <>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <h1>This is SingleProject</h1>
        {/* <iframe src="https://www.notion.so/Engineering-Exploration-5-857c5682940e482c8c726c8dd6069eb3?pvs=4" allowFullScreen></iframe> */}
    </>
}

export default SingleProject;
